"use client";
import { jsx as a, jsxs as d } from "react/jsx-runtime";
import { Table as l, Paragraph as t } from "@ingeniorforeningen/figurine-core";
import { forwardRef as m } from "react";
const i = m(
  (c, n) => {
    const { items: s } = c;
    return /* @__PURE__ */ a("div", { ref: n, children: /* @__PURE__ */ a(l, { children: /* @__PURE__ */ a(l.Tbody, { children: s?.map(({ description: e, amount: r }, o) => /* @__PURE__ */ d(l.Tr, { children: [
      /* @__PURE__ */ a("td", { "aria-label": e, children: /* @__PURE__ */ a(t, { text: e }) }),
      /* @__PURE__ */ a("td", { "aria-label": r, children: /* @__PURE__ */ a(t, { text: r, align: "right", variant: "success" }) })
    ] }, `tabelCalculationItem${o}`)) }) }) });
  }
);
i.displayName = "TablesCalculation";
const f = i;
export {
  i as _TablesCalculation,
  f as default
};
